const operator = '051b413f-0245-4e84-9228-f3c7c5f8d299'

const stagingAustriaConfig = {
  operatorUUID: operator,
  theme: 'evo-hp',
  logo: 'logo.png',
  currency: 'EUR',
  showRegions: false,
  paymentMethods: ['credit_card'],
  mobilePrefix: '+43',
  homeURL: 'https://evofitness.at',
  termsURL: 'https://evofitness.at/allgemeine-mitgliedschaftsbedingungen-von-evo/',
  friendlyCaptchaSitekey: 'FCMQGBDD9FICCIF7',
  locales: {
    all: ['de-AT', 'en-AT'],
    defaultLocale: 'de-AT'
  },
  tracking: {
    gtm: {
      id: undefined
    },
    adtraction: {
      c: undefined,
      tp: undefined,
      ap: undefined
    }
  },
  dibs: {
    callbackURL: `https://dibs-api.staging.credlock.net/${operator}/signup`,
    test: 'yes'
  },
  mypage: {
    url: 'https://mypage-ui-at.staging.credlock.net'
  },
  // sent as return_url with the completed quote so payment returns to this host
  paymentPath: '/processing-payment',
  features: ['doc-signing']
}

export default stagingAustriaConfig
